export const HINDI = {
	COMPLTETE_YOUR_PAYMANT: 'पेमेंट कम्पलीट करें',
	UPI_ENTERED: 'UPI ID / VPA दर्ज:',
	OPEN: 'खोलें',
	CHECK_PENDING_REQUEST: 'लंबित आवेदन जांचें और पेमेंट करने के लिए UPI PIN दर्ज करें',
	SOMETHING_WENT_WRONG: 'कुछ गलत हुआ',
	TRY_AGAIN: 'दोबारा कोशिश करें',
	BALANCE: 'शेष',
	RECOMMENDED: 'सिफारिश',
	SAFE_SECURE: '100% सुरक्षित',
	PROCESSING_PAYMENT: 'हम पेमेंट प्रसंस्करण कर रहे हैं...',
	TAKING_LONGER: 'This is taking longer than usual. Please wait...',
	WANT_TO_EXIT: 'क्या आप निसंदेह जाना चाहते हैं?',
	YES: 'हाँ',
	NO: 'नहीं',
	CANCEL: 'रद्द करें',
	SELECT_PAYMENT_METHO: 'पेमेंट का तरीका चुनें',
	BHARATPE: 'BharatePe',
	ENETR_OTP_SENT_TO: 'इधर भेजा OTP डालें',
	VERIFY_OTP: 'OTP सत्यापित करें',
	INVALID_UPI_VPA: 'अमान्य UPI ID / VPA कृपया दोबारा कोशिश करें',
	CHOOSE_UPI_HANLDE: 'UPI हैंडल चुनें',
	VPA_SELECTED: 'VPA चुना गया',
	PAY: 'पेमेंट करें',
	PAYMANT_BY_UPI: 'UPI से पेमेंट करें',
	SUB_Header_Text: 'प्राप्तकर्ता:',
	Amount: 'राशि',
	X_Fast_Tag: 'x 2FASTag',
	COMPLTETE_YOUR_PAYMENT: 'पेमेंट कम्पलीट करें',
	ID_VPA_ENETERED: 'ID / VPA दर्ज: ',
	GOOGLE_PAY: 'Google Pay ',
	APP: 'एप्प',
	CHECKING_PAYMENT_REQUEST: 'लंबित आवेदन जांचें और\n',
	COMPLETE_THIS_PAYMENT_IN: 'इसमें पेमेंट पूरा करें',
	DONT_GO_BACK: 'कृपया जब तक पेमेंट पूरी न हो जाए वापस ना जाएँ या रीफ़्रेश न करें',
	SAFE_AND_SECURE: '100% सुरक्षित',
	TRANSACTION_STATUS: 'लेनदेन की स्थिति जांचें',
	ENTER_YOUR_UPI_ID_VPA: 'अपना UPI ID / VPA दर्ज करें',
};
